<template>
  <v-row no-gutters >
    <v-col>
      <template v-for="(r, ri) in headerRows">
        <v-row v-if="r.showGroupHeader"
        :key="'rgh' + ri"
        no-gutters
        class="flex-nowrap">
          <v-col class="group-header sub-row"
              v-for="(c, ci) in (r.detail?.children || [])"
              :key="'rgh' + ri + 'c' + ci"
              :style="c.colCSS"
              :class="ci === (r.detail?.children || []).length - 1 ? 'last-column' : ''"
          ></v-col>
        </v-row>
        <v-row
          :key="'r' + ri"
          no-gutters
          class="flex-nowrap"
        >
          <v-col
            v-if="r.isDetail || r.hideDetails"
            :style="{ height: r.height }" 
          >
            <v-row no-gutters style="height: 100%;" class="flex-nowrap"> 
              <v-col
                v-for="(c, ci) in (r.detail.children)"
                :key="'r' + ri + 'c' + ci"
                :style="c.colCSS"
                :class="(r.hideDetails ? c.cssClassDetail : '') + ' col-resizable'"
                >
                <div class="col-resize-handle" title="Drag to resize columns; double-click to reset"
                  @click.stop
                  @dblclick.stop="$emit('resetColumnWidth', 'H')"
                  @pointerdown.stop.prevent="$emit('resizeColumn', $event, 'H', null, c.colWidth)"></div>
                <!-- <v-row no-gutters
                  ><v-col
                    v-for="(sc, sci) in (c.children)"
                    :key="'r' + ri + 'c' + ci + 'sc' + sci"
                  > col detail{{ ri }} {{ sci }} {{ sc.zContainer }} -->
                    <HierarchyViewColumnDetail v-if="!r.isGroupHeader && !r.hideDetails"
                      :item="c"
                      :detailDef="detailDef"
                      :visibleMeasures="visibleMeasures"
                      :showDetails="showDetails"
                      :catalogueDocType="catalogueDocType"
                      :vScroll="vScroll"
                      :searchTerms="searchTerms"
                      :hideNodeActions="hideNodeActions"
                      @selectJob="$emit('selectJob', ...arguments)"
                      @openDocListMenu="$emit('openDocListMenu', ...arguments)"
                      @openDocActionsMenuContext="
                        $emit('openDocActionsMenuContext', ...arguments)
                      "
                      @openDocument="$emit('openDocument', ...arguments)"
                      @copyDocument="$emit('copyDocument', ...arguments)"
                      @showMatches="$emit('showMatches', ...arguments)"
                      @dragStart="$emit('dragStart', ...arguments)"
                      @doMenuAction="$emit('doMenuAction', ...arguments)"
                      @viewNodeDoc="$emit('viewNodeDoc', ...arguments)"
                      @removeAdditionNode="
                        $emit('removeAdditionNode', ...arguments)
                      "
                      @showLinkedDocs="$emit('showLinkedDocs', ...arguments)"
                      @drilldown="$emit('drilldown', ...arguments)"
                      @resizeColumn="$emit('resizeColumn', ...arguments)"
                      @resetColumnWidth="$emit('resetColumnWidth', ...arguments)"
                    ></HierarchyViewColumnDetail>
                  <!-- </v-col>
                </v-row> -->
              </v-col>
            </v-row>
          </v-col>
          <v-col v-else-if="r.subRows.length">
            <RowDetails
              :headerRows="r.subRows"
              :visibleMeasures="visibleMeasures"
              :catalogueDocType="catalogueDocType"
              :detailDef="detailDef"
              :showDetails="showDetails"
              :vScroll="vScroll"
              :searchTerms="searchTerms"
              :hideNodeActions="hideNodeActions"
              @selectJob="$emit('selectJob', ...arguments)"
              @openDocListMenu="$emit('openDocListMenu', ...arguments)"
              @openDocActionsMenuContext="
                $emit('openDocActionsMenuContext', ...arguments)
              "
              @openDocument="$emit('openDocument', ...arguments)"
              @copyDocument="$emit('copyDocument', ...arguments)"
              @showMatches="$emit('showMatches', ...arguments)"
              @dragStart="$emit('dragStart', ...arguments)"
              @doMenuAction="$emit('doMenuAction', ...arguments)"
              @viewNodeDoc="$emit('viewNodeDoc', ...arguments)"
              @removeAdditionNode="$emit('removeAdditionNode', ...arguments)"
              @showLinkedDocs="$emit('showLinkedDocs', ...arguments)"
              @drilldown="$emit('drilldown', ...arguments)"
              @resizeColumn="$emit('resizeColumn', ...arguments)"
              @resetColumnWidth="$emit('resetColumnWidth', ...arguments)"
            ></RowDetails>
          </v-col>
        </v-row>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import HierarchyViewColumnDetail from "@/components/jobArchitecture/HierarchyViewColumnDetailAlt";

export default {
  name: "RowDetails",
  components: {
    HierarchyViewColumnDetail,
  },
  props: {
    headerRows: { type: [], required: true },
    visibleMeasures: { type: [], required: true },
    catalogueDocType: { type: Object, required: false },
    detailDef: { type: Object, required: false },
    showDetails: { type: Boolean, required: false },
    vScroll: { type: Object, required: false },
    searchTerms: { type: [], required: false },
    hideNodeActions: { type: Boolean, required: false },
  },
  data: function () {
    return {
      response: null,
    };
  },
  watch: {},
  computed: {},
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped>

</style>